export class Message {
  static SAVE: string = "تم حفظ البيانات بنجاح";
  static SUCCESS_LOGIN: string = "تم تسجيل الدخول بنجاح";
  static SUCCESS_LOGOUT: string = "تم تسجيل الخروج بنجاح";
  static UPDATE: string = "تم تعديل البيانات بنجاح";
  static DELETE: string = "تم حذف البيانات بنجاح";
  static UN_HANDLED_ERROR: string = "حدث خطأ برجاء المحاولة مرة أخرى";
  static NOT_ACTIVE_USER: string =
    "هذا المستخدم غير نشط برجاء مراجعة مدير النظام";
  static CHOOSE_ENGINE_FIRST: string =
    "من فضلك اختر المحرك قبل كتابة قراءة الساعه الخاصة به";
  static ORDER_WILL_GENERATED: string =
    "سيتم عمل أمر صيانه لهذا المحرك عند الحفظ";
  static ERROR_IN_GET_LAST_ENGINE_HOURS: string =
    "خطأ في استرجاع اخر صيانة للمحرك";
  static ENGINE_HOURS_MUST_BE_GREATER_THAN_PREV_READ: string =
    "قراءة ساعه المحرك يجب ان تكون اكبر من السابقة";
  static ORDER_GENERATED_SUCCESSFULLY: string =
    "تم إصدار أمر شغل بنجاح لهذا المحرك";
  static ERROR_LOAD_INIT_DATA: string =
    "خطأ تحميل البيانات الاساسية برجاء تحديث الصفحة";
  static MAINTENANCE_SKIPPED: string = "تم تخطي صيانة ";
  static ORDER_GENERATED_UPDATED_SUCCESSFULLY: string =
    "تم تعديل بيانات أمر التشغيل المرتبط";
  static ORDER_GENERATED_REMINDERED_SUCCESSFULLY: string =
    "تم التذكير بأوامر التشغيل غير المنفذة";
  static ENGINE_HAS_NONE_REVIEWED_VISIT: string =
    "يوجد زيارة لهذا المحرك لم تتم مراجعتها";
  static ORDER_EXECURED: string = "تم تنفيذ أمر التشغيل";
  static ORDER_EXECURED_REVIEWED: string = "تم مراجعة تنفيذ أمر التشغيل";
  static CANCEL_CHANGES: string = "تم إلغاء التعديلات بنجاح";
  static DO_ALL_TASKS: string = "يرجى تنفيذ جميع أعمال الصيانة أولا";
  static ADDED_BEFORE_PLAESE_CHECK: string =
    "تم إضافة هذه البيانات من قبل برجاء التأكد ثم المحاولة مرة أخرى";
  static MUST_ADD_TO: string = "لابد من اختيار المخزن المصروف له الكمية";
  static MUST_BE_MORE_THAN_ZARO: string = "الكمية يجب ان تكون اكبر من صفر";
  static MUST_SELECT_POWERCOACH: string = "لابد من اختيار العربة والمحرك";
  static CREDIT_NOT_ENOUGH: string = "رصيد المخزن غير كاف";
  static UPDATE_LAST_VISIT_FIRST: string =
    "يوجد زيارة لم يتم مراجعتها برجاء المراجعه أولا";

  static REVIEW_HOURSREAD: string = "يرجى مراجعة عداد الساعات";
}
